module.exports = __webpack_public_path__ + "src/img/audioIcon.417e148b.svg";